import { getFunctions, httpsCallable } from 'firebase/functions';
import type { IFunctionsService } from '@breath-lab/services';
import { firebaseApp } from '../firebase/firebaseConfig';

export class WebFunctionsService implements IFunctionsService {
  async fetchSessionToken(params: {
    breathworkId?: string;
    journeyId?: string;
  }): Promise<{ expiresAt: number }> {
    const fns = getFunctions(firebaseApp);
    const callable = httpsCallable<
      { breathworkId?: string; journeyId?: string },
      { expiresAt: number }
    >(fns, 'requestBreathworkSession');
    const result = await callable(params);
    return result.data;
  }
}
